import React from 'react'

function PaymentRequest() {
  return (
	<div>PaymentRequest</div>
  )
}

export default PaymentRequest